// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c07772c1","453":"a8ade8e0"}[chunkId] + ".chunk.js";
};